// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tippy-container[data-v-54868201]{width:100%;display:inline-block}.popover-content-container[data-v-54868201]{max-width:350px}.light-mode .popover-content-container[data-v-54868201]{box-shadow:4px 4px #000;border:1px solid #000}.dark-mode .popover-content-container[data-v-54868201]{box-shadow:4px 4px #fff;border:1px solid #fff}.break-word[data-v-54868201]{overflow-wrap:break-word}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
